export const appDownloadLink = "https://dalmobile.page.link/HtTC";
